// extracted by mini-css-extract-plugin
export default {"container":"yalla_container__JUAmo","aboutSec":"yalla_aboutSec__2RLyd","subText":"yalla_subText__m2s+d"};